import React from 'react'

const Reviews = () => {
  return (
    <>
        <div className="reviews">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h1>ОТЗЫВЫ</h1>
                    </div>
                    <div className="col-6 p-2 mt-lg-5 mt-3">
                        <div className='wrap'></div>
                    </div>
                    <div className="col-6 p-2 mt-lg-5 mt-3">
                        <div className='wrap'></div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Reviews
